<div class="sb-tab-nav-bar" [class.sb-tab-nav-bar--transparent]="transparentBackground()">
  <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
  <div class="sb-tab-nav-bar-list" role="tablist" (keydown)="onKeyDown($event)">
    @for (tab of tabs(); track tab.id; let index = $index) {
      <div
        role="tab"
        class="sb-tab-nav-bar-list-link"
        sbTabLabel
        [disabled]="tab.disabled"
        [id]="tab.tabLabelId"
        (click)="tab.disabled ? null : selectTabByIndex(index)"
        (keydown.enter)="tab.disabled ? null : selectTabByIndex(index)"
        (keydown.space)="tab.disabled ? null : selectTabByIndex(index); $event.preventDefault()"
        [attr.tabIndex]="index === selectedIndex() ? 0 : -1"
        [attr.aria-selected]="selectedIndex() === index"
        [attr.aria-controls]="tab.tabContentId"
      >
        @let tabIcon = tab.icon();
        @if (tabIcon) {
          <sb-icon [name]="tabIcon" class="shrink-0" />
        }
        <span class="font-title">{{ tab.title }}</span>
      </div>
    }
  </div>
</div>
@if (!hideTabContent()) {
  <div class="sb-tab-body" [class.sb-tab-body--no-padding]="noPadding()" sbScrollable>
    @for (tab of tabs(); track tab.id; let index = $index) {
      <div
        role="tabpanel"
        class="sb-tab-body-content"
        [class.h-full]="containHeight()"
        [id]="tab.tabContentId"
        [attr.aria-hidden]="selectedIndex() !== index"
        [attr.aria-labelledby]="tab.tabLabelId"
      >
        @if (selectedIndex() === index) {
          <ng-template [ngTemplateOutlet]="tab.template"></ng-template>
        }
      </div>
    }
  </div>
}
